const nav = document.querySelector(".nav");
const navToggle = document.querySelector(".nav-toggle");
const navPanel = document.querySelector(".nav-panel");
const navLinks = navPanel ? navPanel.querySelectorAll(".nav-panel-nav a") : [];
const heroVideo = document.querySelector(".hero-video");
const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
let menuOpen = false;

const setMenu = (open) => {
  menuOpen = open;
  nav.classList.toggle("is-open", open);
  navPanel.classList.toggle("is-open", open);
  navPanel.setAttribute("aria-hidden", open ? "false" : "true");
  navToggle.setAttribute("aria-expanded", open ? "true" : "false");
  document.body.style.overflow = open ? "hidden" : "";
};

const openMenu = () => {
  setMenu(true);
  if (window.gsap && !reduceMotion) {
    gsap.fromTo(navPanel, { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.45, ease: "power2.out" });
    gsap.fromTo(
      ".nav-panel-logo",
      { scale: 0.85, autoAlpha: 0 },
      { scale: 1, autoAlpha: 1, duration: 0.6, ease: "power2.out" }
    );
    gsap.fromTo(
      navLinks,
      { y: 36, autoAlpha: 0 },
      { y: 0, autoAlpha: 1, duration: 0.7, stagger: 0.07, delay: 0.12, ease: "power3.out" }
    );
  }
};

const closeMenu = () => {
  if (window.gsap && !reduceMotion && menuOpen) {
    gsap.to(navLinks, { y: 12, autoAlpha: 0, duration: 0.22, stagger: 0.03, ease: "power2.in" });
    gsap.to(".nav-panel-logo", { autoAlpha: 0, duration: 0.2 });
    gsap.to(navPanel, {
      autoAlpha: 0,
      duration: 0.35,
      delay: 0.08,
      ease: "power2.in",
      onComplete: () => setMenu(false),
    });
  } else {
    setMenu(false);
  }
};

if (navToggle && navPanel) {
  navToggle.addEventListener("click", () => {
    menuOpen ? closeMenu() : openMenu();
  });
  navLinks.forEach((link) => {
    link.addEventListener("click", () => closeMenu());
  });
}

if (heroVideo) {
  heroVideo.play().catch(() => {});
}

if (window.gsap && window.ScrollTrigger && !reduceMotion) {
  gsap.registerPlugin(ScrollTrigger);

  const fadeUp = (targets, trigger) => {
    gsap.from(targets, {
      y: 28,
      autoAlpha: 0,
      duration: 1,
      stagger: 0.08,
      ease: "power3.out",
      scrollTrigger: { trigger, start: "top 82%" },
    });
  };

  gsap.from(".hero-logo, .hero-center h1, .hero-lead, .hero-cta", {
    y: 28,
    autoAlpha: 0,
    duration: 1.15,
    stagger: 0.12,
    ease: "power3.out",
    delay: 0.15,
  });

  gsap.fromTo(
    ".hero-video",
    { scale: 1.1, yPercent: -12 },
    {
      scale: 1.18,
      yPercent: 16,
      ease: "none",
      scrollTrigger: { trigger: ".hero", start: "top top", end: "bottom top", scrub: true },
    }
  );

  gsap.to(".hero-shade", {
    yPercent: 8,
    ease: "none",
    scrollTrigger: { trigger: ".hero", start: "top top", end: "bottom top", scrub: true },
  });

  gsap.to(".hero-center", {
    yPercent: 28,
    autoAlpha: 0,
    ease: "none",
    scrollTrigger: { trigger: ".hero", start: "top top", end: "70% top", scrub: true },
  });

  document.querySelectorAll(".story-media img, .origin-grid img, .feature-media .nfc-bag, .feature-media img").forEach((img) => {
    const pin = img.closest("figure, .story-media, .feature-media");
    gsap.fromTo(
      img,
      { scale: 1.14 },
      {
        scale: 1,
        ease: "none",
        scrollTrigger: { trigger: pin, start: "top 90%", end: "bottom top", scrub: true },
      }
    );
  });

  gsap.to(".story-media img", {
    yPercent: 10,
    ease: "none",
    scrollTrigger: { trigger: ".story", start: "top bottom", end: "bottom top", scrub: true },
  });

  fadeUp(".story-copy > *", ".story");
  fadeUp(".principles .eyebrow, .principles li", ".principles");
  fadeUp(".fresh > .eyebrow, .fresh > h2, .fresh > p, .proof article", ".fresh");
  fadeUp(".origin-grid figure", ".origin");
  fadeUp(".feature-copy > *", ".feature");
  fadeUp(".shop .section-head > *, .product, .shop-more", ".shop");
  fadeUp(".cta > *", ".cta");
}
